<template>
  <div class="subir-csv card-deck">
    <div class="card border-0">
      <div class="card-heading bg-light">
        <h2 class="text-center mt-3 mb-3">
          <i class="fas fa-file-csv"></i> Subir Santoral
        </h2>
      </div>
      <div class="card-body px-0">
        <el-upload
          ref="csvUploader"
          class="cvs-upload"
          :headers="apiHeaders"
          :action="apiUploadCSV"
          accept="text/csv"
          name="file"
          :multiple="false"
          :file-list="fileCSV"
          auto-upload
          :on-success="handleSuccess"
          :on-error="handleUploadError"
        >
          <el-button type="primary">
            <i class="fas fa-upload"></i> Clic para subir archivo
          </el-button>
          <div slot="tip" class="el-upload__tip">Sólo archivos .csv</div>
        </el-upload>
        <p class="mt-3 csv-ejemplo">
          <a class href="../files/CSV-Ejemplo.csv">
            <el-button plain type="" class="text-secondary">
              <i class="fas fa-download"></i>
              Descargar CSV de ejemplo
            </el-button>
          </a>
        </p>
      </div>
      <div class="warningModalDiv">
        <b-modal ref="warningModalRef" id="warningModal" title="Info" @ok="clearFiles">
          <div class="card">
            <div class="card-header">{{resultados}}</div>
            <ul v-if="errors.length > 0" class="list-group list-group-flush">
              <li
                class="list-group-item bg-info"
                v-for="(error, index) in errors"
                :key="index"
              >{{error}}</li>
            </ul>
          </div>
        </b-modal>
      </div>
    </div>
    <decode-ref></decode-ref>
  </div>
</template>

<script>
import DecodeRef from "./DecodeRef";
import axios from "axios";
import { APIENDPOINT } from "@/backend";

export default {
  components: {
    "decode-ref": DecodeRef
  },
  data() {
    return {
      fileCSV: null,
      apiUploadCSV: APIENDPOINT + "/api/v1/admin/holydays/upload-csv",
      apiHeaders: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("token")).access_token
      },
      referencia: "",
      ayuda: "",
      codigo: "",
      resultados: "",
      errors: []
    };
  },

  methods: {
    uploadCSV() {
      console.log(this.file);
      this.mensaje = "Subiendo...";
      let fileData = new FormData();
      fileData.append("file", this.file);
      axios({
        baseURL: APIENDPOINT,
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
          "content-type": "multipart/form-data"
        },
        method: "post",
        url: "/api/v1/admin/holydays/upload-csv",
        data: fileData
      })
        .then(response => {
          console.log(response);
          console.log("then");
          this.$refs.warningModalRef.show();
          if (response.data.code === 0) {
            this.resultados = "Archivo subido correctamente";
          } else if (response.data.code === 14) {
            /* ha habido fallos dentro del CSV */
            this.resultados = response.data.description;
            this.errors = response.data.data.errors;
          } else if (response.data.code === 17) {
            // el back a veces pierde su carpeta temporal y es necesario reenviar la petición
            this.resultados = "Ha sucedido un error en el sistema";
            this.uploadCsv();
          } else {
            this.resultados = response.data.description;
          }
        })
        .catch(error => {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            console.log(error);
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            this.mensaje = "Sin respuesta del servidor";
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log(error);
          }
        });
    },

    handleSuccess(response, file) {
      console.group("handleSuccess");
      console.log(response);
      console.groupEnd();
      this.$refs.warningModalRef.show();
      if (response.code === 0) {
        this.resultados = "Archivo subido correctamente";
      } else if (response.code === 14) {
        /* ha habido fallos dentro del CSV */
        this.resultados = response.description;
        this.errors = response.data.errors;
      } else if (response.code === 17) {
        // el back a veces pierde su carpeta temporal y es necesario reenviar la petición
        this.resultados = "Ha sucedido un error en el sistema";
        this.uploadCSV();
      } else {
        this.resultados = response.description;
      }
      console.log(this.resultados);
    },

    handleUploadError(msg, file) {
      console.log("Fail Msg:", msg);
      console.log("File Details", file);

      if (msg.status !== 404) {
        this.$notify.error({
          title: "Error en subida",
          message: "No se ha podido subir el archivo [" + file.name + "]",
          duration: 0
        });
      } else {
        this.$notify.error({
          title: "Path Not Found",
          message: "No such path on the server to upload to",
          duration: 0
        });
      }
    },

    clearFiles() {
      this.$refs.csvUploader.clearFiles();
    }
  },

  computed: {
    uploadDisabled() {
      // console.log(this.file)
      return this.file !== "";
    }
  }
};
</script>

<style scoped>
</style>
